import { TextField, withStyles } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import React from "react";
import LogoProdap from "../../layout/views/logoProdap";
import { DatePicker, TextLabel } from "../../shared/components";
import { PAGE_TYPE } from "../conciliacaoUtil";
import ConciliationDetailedTable from "./conciliationDetailedTable";
import ConciliationSummaryTable from "./conciliationSummaryTable";

const ConciliationPrintTemplate = ({
  categoryOptions,
  classes,
  conciliationData,
  conciliationSummary,
  endDate,
  farm,
  onGetDetailedCollectData,
  onShowDetailsModal,
  selectedCategory,
  startDate,
}) => {
  const { t } = useTranslations();

  const farmName = (farm.Fazendas || []).find(
    (v) => v.IdFazenda === farm.FazendaSelecionada
  ).NomeReduzido;

  const selectedCategoryOption = categoryOptions.find(
    (v) => v.value === selectedCategory
  );

  const getPageMargins = () => {
    return `
    @media all {
      .page-break {
        display: none;
      }
    }
    @media print {
      html, body {
        height: initial !important;
        overflow: initial !important;
        -webkit-print-color-adjust: exact;
      }
      .page-break {
        display: block;
        page-break-before: auto;
      }
    }
    @page {
      size: auto;
      margin: 6mm 0 0 0;
      size: portrait;
    }
    `;
  };

  return (
    <div>
      <style>{getPageMargins()}</style>
      <div className={classes.container}>
        <div style={{ width: "100%" }}>
          <div className={classes.logoContainer}>
            <LogoProdap genericClass={classes.logo} id="logoPropdapAppBar" />
          </div>
          <div className={classes.titleContainer}>
            <TextLabel size={21} style={{ flex: 2 }} id="tituloDoAppBar">
              {farmName}
            </TextLabel>
          </div>
        </div>

        <div className={classes.filtersContainer}>
          <div style={{ marginTop: 10, marginBottom: 22 }}>
            <TextLabel
              size={18}
              bold
              style={{ textTransform: "uppercase" }}
              customStyle={{ color: "#424242" }}
              id="tituloPage"
            >
              {t("conciliation:herd-conciliation")}
            </TextLabel>
          </div>
          <div className={classes.filterRow}>
            <div className={classes.inputFields}>
              <TextField
                id="categoria-nome"
                label={t("animalCategory:category")}
                style={{ width: "100%" }}
                value={selectedCategoryOption.label}
                margin="none"
              />
            </div>
            <div className={classes.dateFields}>
              <DatePicker
                label={t("common:fields.start-date")}
                value={startDate}
                minDate={startDate}
                customStyle={{ marginLeft: 5 }}
              />
            </div>
            <div className={classes.dateFields}>
              <DatePicker
                label={t("common:fields.end-date")}
                value={endDate}
                minDate={endDate}
              />
            </div>
          </div>
        </div>

        <div style={{ margin: "1rem" }}>
          <ConciliationSummaryTable
            summary={conciliationSummary}
            pageType={PAGE_TYPE.PRINT}
          />
          <hr className={classes.horizontalRule} />

          <ConciliationDetailedTable
            conciliationData={conciliationData}
            onGetDetailedCollectData={onGetDetailedCollectData}
            onShowDetailsModal={onShowDetailsModal}
            pageType={PAGE_TYPE.PRINT}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "1200px",
    boxSizing: "border-box",
  },
  logo: {
    width: "101px",
    height: "35px",
    cursor: "pointer",
  },
  logoContainer: {
    marginTop: 21,
    marginLeft: "1.4rem",
    position: "absolute",
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 90,
    width: "100%",
  },
  filtersContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "100%",
    marginLeft: "1.4rem",
  },
  filterRow: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-start",
    height: 96,
  },
  inputFields: {
    maxWidth: 255,
    width: "100%",
    marginRight: 32,
  },
  dateFields: {
    marginRight: 32,
    minWidth: 102,
    maxWidth: 238,
  },
  titulo: {
    fontSize: "16px",
    fontWeight: "500",
    fontFamily: "Roboto",
    color: "#424242",
    marginBottom: "20px",
  },
  horizontalRule: {
    color: "#eeeeee",
    opacity: 0.3,
    height: "2px",
    width: "100%",
    marginTop: "32px",
    marginBottom: "28px",
  },
};

export default withStyles(styles)(ConciliationPrintTemplate);
